module.exports = __webpack_public_path__ + "static/img/return.324790a0.png";